import Service from "../../AuthService";
const factoryEmployeeImport = {
    getFactoryEmployeeImport(page,data){
        return Service.get(`factory_employee_import?page=${page}` +
            `&factory_id=${data.factory_id}` +
            `&date=${data.date}` +
            `&employee_id=${data.employee_id}`
        );
    },
    showFactoryEmployeeImport(id){
        return Service.get('/factory_employee_import/'+id);
    },
    createFactoryEmployeeImport(data){
        return Service.post('/factory_employee_import',data);
    },
    updateFactoryEmployeeImport(id,data){
        return Service.put('/factory_employee_import/'+id,data);
    },
    deleteFactoryEmployeeImport(id){
        return Service.delete('/factory_employee_import/'+id);
    },
}
export default factoryEmployeeImport
